<template>
  <OnClickOutside @trigger="closeDropdown" class="relative">
    <SlotButton
      class="w-full flex items-center justify-start"
      @click="isDropdownOpen = !isDropdownOpen"
      id="res-action-menu"
      alt
    >
      <span class="inline-block mx-auto">Actions</span>
      <ChevronDown class="text-current w-4 h-4" />
    </SlotButton>
    <div
      id="res-action-menu-dropdown"
      v-show="isDropdownOpen"
      class="absolute z-10 mt-2 w-64 origin-top-right rounded-md bg-surface-primary shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
    >
      <div class="p-4 space-y-2">
        <span
          @click="onEditReservation"
          id="venue-reservation-edit"
          class="text-fg-link-primary block text-base font-sans hover:cursor-pointer"
        >
          Edit Reservation
        </span>
        <span
          @click="onEditGuest"
          id="venue-edit-guest"
          class="text-fg-link-primary block text-base font-sans hover:cursor-pointer"
        >
          Edit Guest
        </span>
        <span
          @click="onRefund"
          id="venue-reservation-refund"
          class="text-fg-link-primary block text-base font-sans hover:cursor-pointer"
        >
          Refund
        </span>
        <span
          @click="onResendEmail"
          id="venue-reservation-resend"
          class="text-fg-link-primary block text-base font-sans hover:cursor-pointer"
        >
          Resend Confirmation Email
        </span>
      </div>
    </div>
  </OnClickOutside>
</template>

<script lang="ts">
import { OnClickOutside } from '@vueuse/components'
import { defineComponent } from 'vue'

import ChevronDown from '@/assets/chevronDown.svg?component'
import SlotButton from '@/common/components/atoms/SlotButton.vue'

export default defineComponent({
  name: 'ReservationActionsDropdown',
  components: { ChevronDown, SlotButton, OnClickOutside },
  props: {
    reservationId: {
      type: Number,
      required: true,
    },
  },
  emits: {
    editReservation: () => true,
    editGuest: () => true,
    refund: () => true,
    resendEmail: () => true,
  },
  data() {
    return {
      isDropdownOpen: false,
    }
  },
  methods: {
    closeDropdown() {
      this.isDropdownOpen = false
    },
    onEditGuest() {
      this.$emit('editGuest')
      this.closeDropdown()
    },
    onRefund() {
      this.$emit('refund')
      this.closeDropdown()
    },
    onResendEmail() {
      this.$emit('resendEmail')
      this.closeDropdown()
    },
    onEditReservation() {
      this.$emit('editReservation')
      this.closeDropdown()
    },
  },
})
</script>
